import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { text } from '../../../text';
import { Icon } from '@npm-registry/eapteka-ui';
import styles from './Favorite.scss';
import { FavoriteProps } from './types';

export const Favorite: FC<FavoriteProps> = ({
  className,
  isActive,
  onClick
}) => {
  const rootClassName = useMemo(() => {
    return clsx([styles.root, className], {
      [styles.isActive]: isActive
    });
  }, [isActive, className]);
  const iconName = useMemo(
    () => (isActive ? 'likeOn' : 'heart'),
    [isActive]
  );
  const label = useMemo(
    () =>
      isActive
        ? text['favorite.remove']
        : text['favorite.add'],
    [isActive]
  );

  return (
    <button
      className={rootClassName}
      onClick={onClick}
      aria-label={label}
    >
      <Icon className={styles.icon} name={iconName} />
    </button>
  );
};
